module.exports = __webpack_public_path__ + "static/media/thumb_XPWU3286_1024.3944b694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_XPWU3286_1024.jpg
// module id = 140
// module chunks = 0